import {
  Title1 as H1,
  Title2 as H2,
  Title3 as H3,
  Title4 as H4
} from '@redoute/titles'
import styled from '@emotion/styled'

const Title1 = styled(H1)`
  font-size: 38px;
  line-height: 130%;
  font-weight: 700;
`

const Title2 = styled(H2)`
  font-size: 21px;
  font-weight: 700;
  line-height: 130%;
`

const Title3 = styled(H3)`
  font-size: 15px;
  font-weight: 700;
`

const Title4 = styled(H4)`
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
`

export { Title1, Title2, Title3, Title4 }
